module.exports = __webpack_public_path__ + "img/contact-map.e486bd2a.png";